<div class="inner">
  <h3>{{ text }}</h3>
  <p>{{ title }}</p>
</div>
<span class="icon" [ngClass]="icon?.variant ? 'bg-' + icon!.variant : ''">
  <fa-icon *ngIf="icon?.content" [icon]="icon!.content!"></fa-icon>
</span>
<a class="small-box-footer" [routerLink]="navigateTo"><span class="mr-2">More info</span><i class="fa fa-arrow-circle-right"></i></a>
<app-overlay-loading *ngIf="loading" [type]="getLoadingPropType()"></app-overlay-loading>